import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

import { LoomPageHeaderPlaceholder } from './LoomPageHeaderPlaceholder.tsx';

export const PageHeaderLoomEntryPoint = LoadableAfterPaint({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-PageHeaderLoomEntryPoint" */ './PageHeaderLoomEntryPoint.tsx'
			)
		).PageHeaderLoomEntryPoint;
	},
	loading: ({ isCircle }) => <LoomPageHeaderPlaceholder isCircle={isCircle} isEnabled />,
});
